module.exports = __webpack_public_path__ + "static/media/teaswap-logo-single.95854a23.png";